import $ from 'jquery'
window.jQuery = $
window.$ = $

const objectFitImages = require('object-fit-images')
require('jquery-match-height-browserify')
require('./stickymenu.js')
require('./stickyshare.js')
;(function($) {
  $(function() {
    'use strict'

    /**
		Smooth Scroll
		**/
    $('a[rel="smoothScroll"]').on('click', function(e) {
      e.preventDefault()

      var target = this.hash
      var $target = $(target)

      $('html, body')
        .stop()
        .animate(
          {
            scrollTop: $target.offset().top - 40
          },
          900,
          'swing'
        )
    })

    /**
		MatchHeight
		**/
    $('.matchHeight').matchHeight()

    /**
		Polyfill object-fit/object-position
		**/
    objectFitImages()
  }) // End Jquery
})(window.jQuery)
